<template>
  <div class="button-design" :style="mocolor">
    <p class="text-design">{{ $t(text) }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'clickme',
    },
    buttonColor: {
      type: String,
      default: '#32A6ED',
    },
  },
  computed: {
    mocolor() {
      return {
        '--button-color': this.buttonColor,
      };
    },
  },
};
</script>

<style scoped>
  .button-design {
    border-radius: 18px;
    background-color: var(--button-color);
    padding: 22px;
    min-width: 60px;
  }

  .button-design > p {
    color: #ffffff;
    margin: 0;
  }

  .button-design:hover {
    opacity: 0.8;
  }

  .text-design {
    text-align: center;
    font-weight: 700;
  }
</style>
